// -----------------------
//  faq
// -----------------------
(function ($) {
  $('.faq .acc-box').on('click', function () {
    const $dt = $(this).find('.ttl');
    const $dd = $(this).find('.text');

    $dt.toggleClass('open');
    $dd.stop(true, true).slideToggle(300, 'swing');
  });
})($224);
